import { Component, OnDestroy, OnInit } from '@angular/core';
import { assets } from '../../core/constants/assets.const';
import { TranslateModule } from '@ngx-translate/core';
import { HeaderComponent } from '../../shared/header/header.component';
import { RouterModule } from '@angular/router';
import { FooterComponent } from '../../shared/footer/footer.component';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { AuthService } from '../../core/services/auth.service';
import { LoginResponse } from '../../models/auth.model';
import { environment } from '../../../environments/environment';
import { SpinnerService } from '../../services/spinner.service';


@Component({
  selector: 'fgsn-ecommerce-website-main',
  standalone: true,
  imports: [TranslateModule, HeaderComponent, RouterModule, FooterComponent],
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss'
})
export class MainComponent implements OnInit, OnDestroy {
 
  private destroy: Subject<boolean> = new Subject<boolean>();
  protected subscriptionSubject$!: Subscription;
  protected profile: LoginResponse | null = null;
  assetsConst = assets;
  constructor(
    public _authService: AuthService,
    private _spinnerService: SpinnerService
  ) {}

  ngOnInit(): void {
    this.subscriptionSubject$ = this._authService.profileDetails
      .pipe(takeUntil(this.destroy))
      .subscribe((res: LoginResponse | null) => {
        if (res !== null) {
          this.profile = res;
        } else {
          if (localStorage.getItem(environment.storageKey)) {
            this.getProfile();
          }
        }
      });
  }

  getProfile(): void {
    this._spinnerService.addToLoader('getProfile');
    this._authService
      .getProfile()
      .pipe(takeUntil(this.destroy))
      .subscribe({
        next: (res: LoginResponse) => {
          this._spinnerService.removeFromLoader('getProfile');
          this.profile = res;
          this._authService.profileDetails.next(res);          
        },
        error: () => {
          this._spinnerService.removeFromLoader('getProfile');
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy.next(true);
    this.destroy.complete();
  }

}
